// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_l1-0";
export var buttonContainer = "_l1-3";
export var cancelButton = "_l1-4";
export var headerSection = "_l1-6";
export var headerTitle = "_l1-9";
export var messageSideLeft = "_l1-1";
export var messageSideRight = "_l1-2";
export var orderNumberContainer = "_l1-7";
export var orderNumberLabel = "_l1-8";
export var submitButton = "_l1-5";